import { useState, useEffect } from "react";

import './Index.css';

import { GetDataPage, RegisterDataPage, UnRegisterDataPage } from "../../interface/Data";
import { SetModalData, SetModalState } from "../../interface/PopUp";
import { Svg_Menu_Admin, Svg_Menu_Client, Svg_Menu_Project } from "../../components/Svg";

interface VersionItem {
    name : string;
}

interface VersionGroup {
    qtd     : number;
    version : number;
    list    : VersionItem[];
}

export default function Page_Index() {

    const [ dataIndex, setDataIndex ] = useState<{ [key: string]: any }>(GetDataPage("index") || {});

    useEffect(() => {
        RegisterDataPage("index", setDataIndex);

        return () => {
            UnRegisterDataPage("index", setDataIndex);
        };
    }, []);

    function ReturnList(key: string){
        return Array.isArray(dataIndex?.[key]) ? dataIndex[key] as VersionGroup[] : [];
    }

    function ReturnTotal(list: VersionGroup[]){
        return list.reduce((total, elem) => {
            return total + Number(elem.qtd || 0);
        }, 0);
    }

    function OpenListVersion(title: string, group: VersionGroup){
        SetModalData('ListVersion', { "title": title, "version": group.version, "list": group.list });
        SetModalState('ListVersion', true);
    }

    const listClient  = ReturnList("clients");
    const listProject = ReturnList("projects");

    const listBloco = [
        {
            name    : "Registered clients",
            qtd     : ReturnTotal(listClient),
            text    : "No registered clients",
            version : listClient,
            icon    : <Svg_Menu_Client color="#EEA23F" />
        },
        {
            name    : "Projects",
            qtd     : ReturnTotal(listProject),
            text    : "No registered projects",
            version : listProject,
            icon    : <Svg_Menu_Project color="#EEA23F" />
        },
        {
            name    : "Admin accesses",
            qtd     : Number(dataIndex?.administrators || 0),
            text    : "Elevated permissions",
            version : [],
            icon    : <Svg_Menu_Admin color="#EEA23F" />
        }
    ];

    return (
        <div className="Page_Index">
            <div className="list_bloco">
                {
                    listBloco.map((elem, index) => {
                        return (
                            <div className="bloco" key={ index }>
                                <div className="bloco_top">
                                    <div className="bloco_name">{ elem.name }</div>
                                    <div className="bloco_icon">{ elem.icon }</div>
                                </div>
                                <div className="bloco_data">
                                    <div className="bloco_qtd">{ elem.qtd }</div>
                                    {
                                        elem.version.length > 0 ?
                                        <div className="list_version">
                                            {
                                                elem.version.map((elem_1, index_1) => {
                                                    return (
                                                        <div className="version" key={ index_1 } onClick={ ()=>{ OpenListVersion(elem.name, elem_1); } }>
                                                            <div className="version_name">Version { elem_1.version }</div>
                                                            <div className="version_qtd">{ elem_1.qtd }</div>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div> : null
                                    }
                                </div>
                                {
                                    elem.version.length > 0 ? null :
                                    <div className="bloco_text">{ elem.text }</div>
                                }
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
}
